let _authToken: string | undefined;
let _userId: string | undefined;
export const setGlobalAuthToken = (token?: string) => {
    if (!!token && typeof window !== "undefined") window.localStorage.setItem("token", token);
    _authToken = token ? token : undefined;
};
export const getGlobalAuthToken = async (): Promise<string | undefined> =>
    !!_authToken
        ? _authToken
        : typeof window !== "undefined"
        ? window.localStorage.getItem("token") || ""
        : "";

export const setGlobalUserId = (userId: string) => {
    if (typeof window !== "undefined") window.localStorage.setItem("userId", userId);
    _userId = userId;
};

export const getGlobalUserId = () => {
    return !!_userId
        ? _userId
        : typeof window !== "undefined"
        ? window.localStorage.getItem("userId") || ""
        : "";
};

export const jsonContentType = "application/json";
export const csvContentType = "text/csv";
// export type HttpContentType = typeof jsonContentType | typeof csvContentType
export type HttpContentType = typeof jsonContentType;

export interface ApiReqHeaders {
    "Content-Type"?: HttpContentType;
    Accept?: HttpContentType;
    Authorization?: string;
    host?: string;
    //AWS headers
    //Taken from http://docs.aws.amazon.com/elasticloadbalancing/latest/classic/x-forwarded-headers.html
    "x-forwarded-proto"?: string;
    "x-forwarded-for"?: string;
    "x-forwarded-port"?: string;
    "x-app-name"?: string;
    "x-app-id"?: string;
    "x-app-version"?: string;
    "x-app-platform"?: string;
    "x-session-id"?: string;
}

const commonDefaultHeaders: ApiReqHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
};

export const defaultHeaders = async (token?: string): Promise<ApiReqHeaders> => {
    const reqToken = token || (await getGlobalAuthToken());
    return reqToken
        ? { ...commonDefaultHeaders, Authorization: "Bearer " + reqToken }
        : commonDefaultHeaders;
};

//Helpful for determining the origin app of the request.
//Helps in debugging on the server through server logs
export const setReqHeaderXAppName = (appName: string) => {
    commonDefaultHeaders["x-app-name"] = appName;
};

export const setReqHeaderXAppId = (appId: string) => {
    commonDefaultHeaders["x-app-id"] = appId;
};

export const setReqHeaderXAppVersion = (appVersion: string) => {
    commonDefaultHeaders["x-app-version"] = appVersion;
};
export const setReqHeaderXAppPlatform = (appPlatform: string) => {
    commonDefaultHeaders["x-app-platform"] = appPlatform;
};
export const setReqHeaderHost = (host: string) => {
    commonDefaultHeaders.host = host;
};
